export const DEFAULT_TOOLBAR_OPTIONS = {
    options: [
        'inline',
        'blockType',
        'fontSize',
        'fontFamily',
        'list',
        'textAlign',
        'colorPicker',
        'link',
        // 'embedded',
        // 'emoji',
        // 'image',
        // 'remove',
        // 'history',
        // 'editorOptions'
    ],
    list: {
        options: ['unordered', 'ordered'],
    },
    // link: {
    //   defaultTargetOption: '_blank'
    // },
    image: {
        // icon: image,
        className: undefined,
        component: undefined,
        popupClassName: undefined,
        urlEnabled: true,
        uploadEnabled: true,
        alignmentEnabled: true,
        uploadCallback: undefined,
        previewImage: true,
        inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
        alt: { present: false, mandatory: false },
        defaultSize: {
            height: 'auto',
            width: '100%',
        },
    }
};

export const EMAIL_TOOLBAR_OPTIONS = {
    options: [
        'inline',
        'blockType',
        'fontSize',
        'fontFamily',
        'list',
        'textAlign',
        'image',
        'colorPicker',
        'link',
    ],
    list: {
        options: ['unordered', 'ordered'],
    },
    image: {
        className: undefined,
        component: undefined,
        popupClassName: undefined,
        urlEnabled: true,
        uploadEnabled: true,
        alignmentEnabled: true,
        previewImage: true,
        inputAccept: 'image/jpeg,image/jpg,image/png,image/webp',
        alt: { present: true, mandatory: false },
        defaultSize: {
            height: 'auto',
            width: '100%',
        },
    }
};